import * as React from 'react';
const h = React.createElement;

export interface ProgressProps {
  percent?: number;
  size?: 'small' | 'default' | 'large';
  showInfo?: boolean;
  strokeColor?: string;
  trailColor?: string;
  className?: string;
}

const Progress: React.FC<ProgressProps> = function Progress(props) {
  const {
    percent = 0,
    size = 'default',
    showInfo = true,
    strokeColor,
    trailColor,
    className = '',
  } = props;
  const barColor = strokeColor || '#6366f1';
  const trackColor = trailColor || '#334155';
  const height = size === 'small' ? 6 : size === 'large' ? 14 : 8;

  return h(
    'div',
    { className: `flex items-center gap-3 ${className}` },
    h(
      'div',
      {
        className: 'flex-1 rounded-full overflow-hidden',
        style: { backgroundColor: trackColor, height },
      },
      h('div', {
        className: 'h-full rounded-full transition-all duration-300',
        style: { width: `${Math.min(100, Math.max(0, percent))}%`, backgroundColor: barColor },
      }),
    ),
    showInfo &&
      h(
        'span',
        { className: 'text-sm text-dark-300 min-w-[3em] text-right' },
        `${Math.round(percent)}%`,
      ),
  );
};

export { Progress };
